import { FormControl, Validators } from '@angular/forms';

import { FileType } from '@empathy/global/data';
import { QuestionType } from '@empathy/survey/base';
import { Question } from '@empathy/survey-core';

import { QuestionForm } from './question-form.model';

export class QuestionFormFileUpload extends QuestionForm {
  private readonly defaultFileSize = 25; // in MB
  private readonly maxFileSize = 250; // in MB

  constructor() {
    super();
    this.extendFormGroup();
  }

  initEmpty(nextId: number, pageId: string): void {
    super.initEmpty(nextId, pageId);
    this.form.get('type').setValue(QuestionType.FileUpload);
  }

  init(question: Question): void {
    super.init(question);
  }

  private extendFormGroup(): void {
    this.form.addControl('allowMultipleInd', new FormControl<boolean>(false));
    this.form.addControl('maxLength', new FormControl<number>(0));
    this.form.addControl('minLength', new FormControl<number>(1));
    this.form.addControl('maxSize', new FormControl<number>(this.defaultFileSize, Validators.max(this.maxFileSize)));
    this.form.addControl(
      'fileTypes',
      new FormControl<FileType[]>([FileType.ImagePng, FileType.ImageJpeg, FileType.ImageGif, FileType.VideoMp4, FileType.AudioMp3, FileType.TextCsv])
    );

    this.form.get('requiredInd').valueChanges.subscribe((requiredInd: boolean) => {
      if (requiredInd && this.form.get('minLength').value === 0) {
        this.form.get('minLength').setValue(1);
      } else if (!requiredInd) {
        this.form.get('minLength').setValue(0);
      }
    });

    this.form.get('minLength').valueChanges.subscribe((minLength: number) => {
      if (minLength > 0 && !this.form.get('requiredInd').value) {
        this.form.get('requiredInd').setValue(true);
      }
    });
  }
}
